import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotificationsinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "m7.177 14.257.089.26a1.72 1.72 0 0 0 2.185 1.065v0a1.72 1.72 0 0 0 1.065-2.185l-.089-.259M8.239 3.903l-.225-.651A1.375 1.375 0 0 0 6.266 2.4v0a1.376 1.376 0 0 0-.853 1.747l.225.651"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M4.165 8.824a3.4 3.4 0 0 1 2.107-4.32l1.286-.442a3.4 3.4 0 0 1 4.32 2.107v0l.682 1.983a1.5 1.5 0 0 0 .76.86l.612.297c.358.175.631.484.76.86v0a1.42 1.42 0 0 1-.879 1.802l-7.6 2.617a1.42 1.42 0 0 1-1.803-.879v0a1.5 1.5 0 0 1 .07-1.146l.297-.611c.175-.358.2-.77.07-1.146z",
		clipRule: "evenodd"
	})]
});
export default SvgNotificationsinline;
